<script lang="ts" setup>
  import { informationCircle } from 'ionicons/icons'

  const props = withDefaults(
    defineProps<{
      message: string
      isError?: boolean
      icon?: string
      iconFontSize?: string
      pulse?: boolean
    }>(),
    {
      isError: false,
      icon: informationCircle,
      iconFontSize: '16px',
      pulse: false
    }
  )

  const elementRef = ref<HTMLElement | null>(null)

  defineExpose({
    element: elementRef
  })
</script>

<template>
  <div
    ref="elementRef"
    :class="[
      'body',
      'error-message-container',
      { 'error-message-container-red': props.isError },
      { 'error-message-container-green': !props.isError }
    ]"
  >
    <ion-icon
      :class="[
        'error-icon',
        { 'error-icon-red': props.isError },
        { 'error-icon-green': !props.isError },
        { 'pulse': props.pulse }
      ]"
      :icon="props.icon"
    />
    {{ message }}
  </div>
</template>

<style lang="scss" scoped>
  .error-message-container {
    display: flex;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 30px;
  }

  .error-message-container-red {
    background: var(--color-secondary-red-lightest);
    color: var(--color-secondary-red-dark);
  }

  .error-message-container-green {
    background: var(--color-secondary-green-lightest);
    color: var(--color-secondary-green-dark);
  }

  .error-icon {
    padding: 0 10px;
    flex-shrink: 0;
    font-size: v-bind('iconFontSize');
  }

  .error-icon-red {
    color: var(--color-base-red);
  }

  .error-icon-green {
    color: var(--color-base-green);
  }
</style>
